module.exports = __webpack_public_path__ + "static/media/S3N11-5.4a92f4b8.svg";